// extracted by mini-css-extract-plugin
export default {"contentElder":"mainElder_contentElder__OXS1k"};